//Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes material
import TextField from '@material-ui/core/TextField';
import Slider from '@material-ui/core/Slider';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';
//Utils
import { validarInteiro, converterNumero } from '../../utils/validacao';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';

/**
* Estilos do componente
*/
const styles = () => ({
    field: {
        width: '100%'
    }
});

/**
 * Componente para renderizar um campo para responder uma questão do tipo inteiro
 */
class AvaliacaoRespostaInteiro extends Component {
    constructor(props) {
        super(props);
        //Binding
        this.handleRespostaChange = this.handleRespostaChange.bind(this);
        this.handleSliderChange = this.handleSliderChange.bind(this);
    }

    /**
     * Trata o evento de alteração do campo
     * @param {*} event Dados do evento de alteração
     */
    handleRespostaChange(event) {
        //Obtendo valor preenchido no campo
        const resposta = event.target.value;
        //Valida se o valor é um inteiro
        if (validarInteiro(resposta)) {
            //Cria uma cópia do objeto
            const questao = AvaliacaoResposta.clone(this.props.questao);
            //Preenche a resposta
            if (resposta.trim() !== '')
                questao.resposta = resposta;
            else
                questao.resposta = '';
            //Dispara o evento de alteração
            if (this.props.onChange)
                this.props.onChange(questao);
        }
    }
    
    /**
     * Trata o evento de alteração do Slider
     * @param {*} event Dados do evento de alteração
     * @param {Numeric} newValue Novo valor informado
     */
    handleSliderChange(event, newValue) {
        //Cria uma cópia do objeto
        const questao = AvaliacaoResposta.clone(this.props.questao);
        //Preenche a resposta
        questao.resposta = newValue;
        //Dispara o evento de alteração
        if (this.props.onChange)
            this.props.onChange(questao);
    }

    render() {

        /** @type {AvaliacaoResposta} */
        const questao = this.props.questao;
        const erro = this.props.erro;
        
        //Identificando mensagem de erro (Erro geral tem preferência)
        let mensagemErro = '';
        if (erro.erroResposta)
            mensagemErro = erro.erroResposta;
        else 
            mensagemErro = erro.resposta;

        if (questao.limitaValor) {
            return (
                <Grid item xs={12} >
                    <FormControl error={!!mensagemErro} className={this.props.classes.field} >
                        <FormLabel component="legend">{questao.titulo}</FormLabel>
                        <Slider
                            value={converterNumero(questao.resposta) ?? questao.valorMinimo}
                            onChange={this.handleSliderChange}
                            valueLabelDisplay="auto"
                            step={1}
                            marks
                            min={questao.valorMinimo}
                            max={questao.valorMaximo}
                        />
                        <FormHelperText>{mensagemErro}</FormHelperText>
                    </FormControl>
                </Grid>
            );
        } else {
            return (
                <Grid item xs={12} >
                    <TextField
                        label={questao.titulo} 
                        placeholder={questao.titulo} 
                        variant="outlined" 
                        size="small"
                        fullWidth 
                        onChange={this.handleRespostaChange}
                        required={questao.obrigatoria}
                        value={questao.resposta ?? ''} 
                        error={!!mensagemErro}
                        helperText={mensagemErro}
                    />  
                </Grid>
            );
        }
    }
}

AvaliacaoRespostaInteiro.propTypes = {
    /** Objeto contendo os dados da questão a ser respondida */
    questao: PropTypes.instanceOf(AvaliacaoResposta).isRequired,
    /** Evento disparado quando a resposta for alterada */
    onChange: PropTypes.func,
    /** Mensagens de erro da resposta */
    erro: PropTypes.shape({ 
        resposta: PropTypes.string,
        erroResposta: PropTypes.string
    }),
    /** Classes CSS para personalização do componente */
    classes: PropTypes.shape({
        field: PropTypes.string
    })
};

AvaliacaoRespostaInteiro.defaultProps = {
    erro: {
        resposta: '',
        erroResposta: ''
    }
};

export default withStyles(styles)(AvaliacaoRespostaInteiro);